// Chakra imports
import { Portal, Box, Flex, Text, Link as ChakraLink, useDisclosure, useToast, useMediaQuery } from "@chakra-ui/react";
// Layout components
import Navbar from "components/navbar/NavbarUser.js";
import Sidebar from "components/sidebar/SidebarApp.js";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useEffect, useState } from "react";
import { useNavigate, Outlet, Link as ReactRouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import routes, {smallRoutes } from "routesApp"

// Custom Chakra theme
export default function Index(props) {
  const user = useSelector((state) => state?.user?.value);
  const [isSmallerThanMedium] = useMediaQuery("(max-width: 47.99em)");
  const isLoggedIn = user.hasOwnProperty("token") ? true : false;
  const priviledges = user.hasOwnProperty("priviledges") ? user.priviledges : [];

  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  // functions for changing the states from components

  const getActiveRoute = (routes) => {
    let activeRoute = "Page";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };

  const NavItemSmall = ({ route, children }) => {
    return (
          <ChakraLink
            as={ReactRouterLink}
            to={route.layout + "/" + route.path}
            mt="3"
          >
            <Box
              mt="2"
              mb="5"
              width="100%"
              fontSize="17"
              color="#000000"
              align="center"
              mr="5"
            >
              {route.icon}
              <Text color="#000000">{route.nameAbbrv}</Text>
            </Box>
          </ChakraLink>
    );
  };

  document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();

  useEffect(() => {
    if (isLoggedIn) {
      if (!user.hasOwnProperty("accountType") || user.accountType !== "organization") {
        toast({
          title: "You are not allowed here",
          description: "You are not allowed here",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        navigate("/auth/login");
        return;
      }
    } else {
      toast({
        title: "Please login to your account",
        description: "Please login to your account",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      navigate("/auth/login");
    }
  }, []);

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar routes={routes} display="none" {...rest} />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: "calc( 100% - 300px )" }}
          maxWidth={{ base: "100%", xl: "calc( 100% - 300px )" }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
          boxShadow={"md"}>
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText={"Akowe"}
                brandText={getActiveRoute(routes)}
                secondary={getActiveNavbar(routes)}
                message={getActiveNavbarText(routes)}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>
          <Box
            mx="auto"
            p={{ base: "20px", md: "30px" }}
            pe="20px"
            minH="100vh"
            pt="50px"
            bg="#ffffff"
          >
            <Outlet />
          </Box>

         { 
          isSmallerThanMedium && (
          <Box
            as="footer"
            w="100%"
            h="80px"
            bg="white"
            color="#000000"
            position="fixed"
            bottom="0"
            left="0"
            paddingTop="0"
            zIndex="100"
          >
            <Flex minWidth='max-content' alignItems='center' justifyContent='space-between'>
              {smallRoutes.map((route) => (
                <NavItemSmall
                  key={route.name}
                  route={route}
                ></NavItemSmall>
              ))}
            </Flex>
          </Box> )
          }

        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
